import { createSlice } from '@reduxjs/toolkit';
// Slice dla aktywnej zakładki w użytkownikach
const opinionsUTabSlice = createSlice({
  name: 'opinionsUTab', // Nazwa slice'a
  initialState: {
    rows: [],
    checkedItems: [], // Lista zaznaczonych checkboxów
    currentPage: 1, // Domyślna strona
    maxPages: 2, // Domyślna maksymalna liczba stron
    sortBy: null,
    sortDirection: null, // Domyślny kierunek sortowania
    
    addModalOpen: false, // Stan modala dodawania

    keyword: '', // Wyszukiwana fraza
    searchValue: '', // Wartość wyszukiwania

    editModalOpen: false, // Stan modala edycji
    editedSport: null, // Dane edytowanego sportu
    needRefresh: 1, // Flaga do wymuszenia odświeżenia
  },
  reducers: {
    setSortListEndpointU: (state, action) => {
      state.sortSortListEndpoint = action.payload; // Ustawienie endpointu sortowania
    },
    toggleNeedRefreshU: (state) => {
      state.needRefresh = state.needRefresh === 1 ? 0 : 1; // Przełączanie flagi odświeżenia
    },
    toggleCheckedItemU: (state, action) => {
      const id = action.payload;
      if (state.checkedItems.includes(id)) {
        // Usuń id, jeśli już istnieje
        state.checkedItems = state.checkedItems.filter((item) => item !== id);
      } else {
        // Dodaj id, jeśli nie istnieje
        state.checkedItems.push(id);
      }
    },
    setPageU(state, action) {
          state.checkedItems = []; // Resetowanie zaznaczonych elementów przy zmianie strony
          state.currentPage = action.payload;
        },
    setMaxPagesU(state, action) {
          state.maxPages = action.payload; // Aktualizacja maksymalnej liczby stron 
        },
    setSortingU(state, action) {
        state.checkedItems = []; // Resetowanie zaznaczonych elementów przy zmianie strony
        const { sortBy, sortDirection } = action.payload;
        state.sortBy = sortBy;
        state.sortDirection = sortDirection;
      },
    toggleAddModalU(state) {
      state.addModalOpen = !state.addModalOpen; // Przełączanie stanu modala dodawania
    },
    toggleEditModalU(state, action) {
      state.editModalOpen = !state.editModalOpen;
      state.editedSport = action.payload || null; // Ustaw dane edytowanego sportu lub resetuj
    },
    clearCheckedItemsU: (state) => {
      state.checkedItems = []; // Resetowanie zaznaczonych elementów
    },
    setKeywordU: (state, action) => {
      state.keyword = action.payload; // Ustawienie wyszukiwanej frazy
    },
    setRowsU(state, action) {
      state.rows = action.payload; // Aktualizacja maksymalnej liczby stron
    },
    setSearchValueU: (state, action) => {
      state.searchValue = action.payload; // Ustawienie wartości wyszukiwania
    },
}});

export const {
  toggleNeedRefreshU,
  toggleCheckedItemU,
  setPageU,
  setMaxPagesU,
  setSortingU,
  toggleAddModalU,
  toggleEditModalU,
  clearCheckedItemsU,
  setKeywordU,
  setSearchValueU,
  setRowsU,
  toggleSortListEndpointU,
  setSortListEndpointU,
 } = opinionsUTabSlice.actions; // Eksport akcji
export default opinionsUTabSlice.reducer;